// @ constants
const actionTypes = require('constants/actionTypes');
const {DATE_FORMAT_API} = require('constants/index');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder.js');

//@ vendors
const moment = require('moment');

const requestOpenYoungBudget = () => ({
    type: actionTypes.OPEN_YOUNG_BUDGET_REQUEST
});

const requestOpenYoungBudgetSuccess = (budgetList) => ({
    type: actionTypes.OPEN_YOUNG_BUDGET_SUCCESS,
    payload: {
        budgetList
    }
});

const requestOpenYoungBudgetFailure = (budgetListError) => ({
    type: actionTypes.OPEN_YOUNG_BUDGET_ERROR,
    payload: {
        budgetListError
    }
});

const setComparativeMonth = (selectedMonth) => ({
    type: actionTypes.OPEN_YOUNG_SET_COMPARATIVE_MONTH,
    payload: {
        selectedMonth
    }
})

const getBudgetList = (immCard, sourceDate) => (dispatch) => {

    const firstDayOfCurrentMonth = moment().startOf('month').format(DATE_FORMAT_API);
    const requestData = {
        query: {
            childContractDetail: {
                contractNumber: immCard.getIn(['contract','number']), 
                pan: immCard.getIn(['interventionList',0,'pan']), 
                productCode: immCard.getIn(['contract','product'])
            },
            sourceDate: sourceDate || firstDayOfCurrentMonth,
            sortBy: "category",
            sortOrder: "asc"
        }
    };

    dispatch(requestOpenYoungBudget());
    return APIPost({
        dispatch,
        url: apiURLBuilder.getURL('openYoungGetBudget'),
        params: requestData
    })
    .then(response => dispatch(requestOpenYoungBudgetSuccess(response)))
    .catch( response => {
        if (!!response.error) {
            dispatch(requestOpenYoungBudgetFailure(response.error));
        } else {
            throw response;
        }
    });
}

module.exports = {
    getBudgetList,
    setComparativeMonth
}
